import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'

export const roadMaintenanceImageStatus = enumerated({
  pending: 'Pendente',
  success: 'Sucesso',
  failed: 'Falhou',
})

export const acceptedFormat = enumerated({
  png: 'PNG',
  jpg: 'JPG',
  webp: 'WEBP',
})

export const roadMaintenanceImageObject = z.object({
  id: z.string().uuid(),
  roadMaintenanceId: z.string().uuid(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  description: z.string().nullish(),
  position: z.number().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  status: roadMaintenanceImageStatus,
})

export type RoadMaintenanceImageType = z.infer<typeof roadMaintenanceImageObject>

export default roadMaintenanceImageObject
export const propertyMap = {
  id: sql`road_maintenance_image.id`,
  roadMaintenanceId: sql`road_maintenance_image.maintenance_id`,
  gcsIdentifier: sql`road_maintenance_image.gcs_identifier`,
  url: sql`road_maintenance_image.url`,
  description: sql`road_maintenance_image.description`,
  position: sql`road_maintenance_image.position`,
  createdAt: sql`road_maintenance_image.created_at`,
  updatedAt: sql`road_maintenance_image.updated_at`,
  deletedAt: sql`road_maintenance_image.deleted_at`,
  status: sql`road_maintenance_image.status`,
}
